export const exterior_view02ImageOptions = {
  angle: 'exterior_view02',
  staticOptions: {
    HullColorways: 1,
    BowSpirit: 1,
    HullTreatment: 1,
    Deck: 1,
    TeakOnSideDecks: 1,
    TeakOnCoachroof: 1,
    Sprayhood: 1,
    Wheel: 1,
    MastAndBoom: 1,
    BoomCover: 1
  },
  mattes: [
    {
      option: 'HullColorways',
      dependency: null
    },
    {
      option: 'BowSpirit',
      dependency: 'Deck'
    },
    {
      option: 'Deck',
      dependency: null
    },
    {
      option: 'TeakOnSideDecks',
      dependency: 'Deck'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/XC45/views/exterior_view02.js